(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[916,1412,53,75],[0,1525,1365,40],[916,1214,188,64],[916,1082,288,64],[916,1280,179,64],[916,1148,253,64],[916,1346,138,64],[0,1082,914,441],[0,0,1920,1080]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_42 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_41 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_40 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_39 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_38 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_37 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_36 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.Bitmap1 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.Bitmap2 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.stripe = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// stripe
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#07504F").beginStroke().moveTo(-41,45).lineTo(-41,-45).lineTo(41,-45).lineTo(41,45).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-41,-45,82.1,90);


(lib.sign_out_text = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutText
	this.instance = new lib.CachedBmp_42();
	this.instance.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_text, new cjs.Rectangle(0,0,26.5,37.5), null);


(lib.sign_out_background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutBackground
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#990000").beginStroke().moveTo(-20,30).lineTo(-20,-30).lineTo(20,-30).lineTo(20,30).closePath();
	this.shape.setTransform(20,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_background, new cjs.Rectangle(0,0,40,60), null);


(lib.menu_line_solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#A26A0F").setStrokeStyle(2,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_line_solid, new cjs.Rectangle(-1,-1,1922,2), null);


(lib.menu_line_gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,1).lineTo(-680,-1).lineTo(680,-1).lineTo(680,1).closePath();
	this.shape.setTransform(680,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_line_gradient, new cjs.Rectangle(0,0,1360,2), null);


(lib.logo_small = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E8DDD5").beginStroke().moveTo(76.2,48.7).lineTo(75.6,48.4).lineTo(75.1,48).lineTo(75.1,48.7).lineTo(75.1,48.7).lineTo(75.1,46.9).lineTo(75.1,46.9).curveTo(75.3,47.7,75.8,48.2).curveTo(76.3,48.7,77,48.7).lineTo(77.8,48.6).lineTo(78.3,48.3).lineTo(78.6,47.9).lineTo(78.6,47.4).curveTo(78.6,47,78.4,46.8).lineTo(77.7,46.3).lineTo(76.9,46).lineTo(76,45.6).lineTo(75.4,45.1).curveTo(75.2,44.8,75.1,44.3).curveTo(75.1,43.7,75.7,43.3).curveTo(76.2,43,77,43).curveTo(77.5,43,77.8,43.1).lineTo(78.4,43.3).lineTo(78.7,43.7).lineTo(78.7,43).lineTo(78.8,43).lineTo(78.8,44.8).lineTo(78.7,44.8).lineTo(78.6,44.2).curveTo(78.4,43.8,78.2,43.6).curveTo(78,43.3,77.8,43.2).curveTo(77.5,43.1,77,43.1).lineTo(76.3,43.2).lineTo(75.9,43.4).lineTo(75.7,43.8).lineTo(75.6,44.2).curveTo(75.6,44.6,75.9,44.8).curveTo(76.1,45.1,76.5,45.3).lineTo(77.4,45.7).lineTo(78.1,46.1).curveTo(78.5,46.3,78.8,46.6).curveTo(79,46.8,79,47.2).lineTo(78.9,47.9).lineTo(78.6,48.3).lineTo(77.9,48.7).lineTo(77,48.8).lineTo(76.2,48.7).closePath().moveTo(53,48.7).lineTo(53.3,48.6).curveTo(53.3,48.6,53.3,48.6).curveTo(53.4,48.6,53.4,48.6).curveTo(53.4,48.5,53.4,48.5).curveTo(53.4,48.5,53.4,48.4).lineTo(53.4,46.8).lineTo(53.5,46.4).lineTo(53.6,46.1).lineTo(54,45.8).lineTo(54.4,45.5).curveTo(54.4,45.5,54.3,45.5).curveTo(54.2,45.5,54.2,45.5).curveTo(54.1,45.4,54.1,45.4).curveTo(54,45.4,54,45.3).lineTo(53.6,45).lineTo(53.5,44.7).lineTo(53.4,44.3).lineTo(53.4,43.3).curveTo(53.4,43.3,53.4,43.3).curveTo(53.4,43.2,53.4,43.2).curveTo(53.4,43.2,53.3,43.2).curveTo(53.3,43.1,53.3,43.1).lineTo(52.9,43.1).lineTo(52.9,43).lineTo(56.2,43).lineTo(56.4,44).lineTo(56.4,44).lineTo(56.2,43.5).lineTo(56.1,43.3).lineTo(55.9,43.1).lineTo(55.4,43.1).lineTo(53.8,43.1).lineTo(53.8,44.1).curveTo(53.8,44.9,54.1,45.2).curveTo(54.4,45.5,55.1,45.5).lineTo(55.2,45.5).lineTo(55.3,45.4).lineTo(55.3,45.1).lineTo(55.4,44.6).lineTo(55.4,44.6).lineTo(55.4,47).lineTo(55.4,47).lineTo(55.3,46.3).lineTo(55.3,45.8).lineTo(55.2,45.6).lineTo(55,45.6).curveTo(54.3,45.6,54.1,45.9).curveTo(53.8,46.2,53.8,47).lineTo(53.8,48.6).lineTo(55.2,48.6).lineTo(55.8,48.6).lineTo(56.1,48.4).lineTo(56.2,48).lineTo(56.5,47.2).lineTo(56.6,47.2).lineTo(56.3,48.7).closePath().moveTo(30.9,48.7).lineTo(33.9,43.1).lineTo(32,43.1).lineTo(31.7,43.1).lineTo(31.5,43.3).lineTo(31.3,43.5).lineTo(31.1,44).lineTo(31,44).lineTo(31.2,43).lineTo(34.5,43).lineTo(31.5,48.6).lineTo(33.1,48.6).lineTo(33.7,48.6).lineTo(34,48.4).lineTo(34.2,48).lineTo(34.5,47.2).lineTo(34.6,47.2).lineTo(34.3,48.7).closePath().moveTo(11.2,48.7).lineTo(11.5,48.6).curveTo(11.6,48.6,11.6,48.6).curveTo(11.6,48.6,11.7,48.6).curveTo(11.7,48.5,11.7,48.5).curveTo(11.7,48.5,11.7,48.4).lineTo(11.7,43.3).curveTo(11.7,43.3,11.7,43.3).curveTo(11.7,43.2,11.7,43.2).curveTo(11.6,43.2,11.6,43.2).curveTo(11.6,43.1,11.5,43.1).lineTo(11.2,43.1).lineTo(11.2,43).lineTo(12.6,43).lineTo(12.6,43.1).lineTo(12.2,43.1).curveTo(12.2,43.1,12.2,43.2).curveTo(12.1,43.2,12.1,43.2).curveTo(12.1,43.2,12.1,43.3).curveTo(12,43.3,12,43.3).lineTo(12,48.4).curveTo(12,48.5,12.1,48.5).curveTo(12.1,48.5,12.1,48.6).curveTo(12.1,48.6,12.2,48.6).curveTo(12.2,48.6,12.2,48.6).lineTo(12.6,48.7).closePath().moveTo(-12,48.7).lineTo(-11.7,48.6).curveTo(-11.7,48.6,-11.6,48.6).curveTo(-11.6,48.6,-11.6,48.6).curveTo(-11.6,48.5,-11.6,48.5).curveTo(-11.5,48.5,-11.5,48.4).lineTo(-11.5,43.3).curveTo(-11.5,43.3,-11.6,43.3).curveTo(-11.6,43.2,-11.6,43.2).curveTo(-11.6,43.2,-11.6,43.2).curveTo(-11.7,43.1,-11.7,43.1).lineTo(-12,43.1).lineTo(-12,43).lineTo(-10.1,43).curveTo(-9.5,43,-8.9,43.2).curveTo(-8.4,43.4,-8,43.7).curveTo(-7.6,44.1,-7.4,44.6).curveTo(-7.2,45.2,-7.2,45.9).curveTo(-7.2,46.6,-7.4,47.1).curveTo(-7.6,47.6,-8,48).curveTo(-8.4,48.4,-8.9,48.5).curveTo(-9.5,48.7,-10.1,48.7).closePath().moveTo(-11.2,48.6).lineTo(-10.4,48.6).curveTo(-9,48.6,-8.4,47.9).curveTo(-7.6,47.2,-7.7,45.9).curveTo(-7.6,44.5,-8.4,43.8).curveTo(-9,43.1,-10.4,43.1).lineTo(-11.2,43.1).closePath().moveTo(-31.8,48.7).lineTo(-31.4,48.6).curveTo(-31.4,48.6,-31.4,48.6).curveTo(-31.4,48.6,-31.4,48.5).curveTo(-31.4,48.5,-31.4,48.5).curveTo(-31.4,48.5,-31.4,48.4).lineTo(-33.2,45.6).curveTo(-33.6,45.8,-33.9,46.1).curveTo(-34.1,46.4,-34.1,47).lineTo(-34.1,48.4).curveTo(-34.1,48.5,-34.1,48.5).curveTo(-34.1,48.5,-34.1,48.6).curveTo(-34.1,48.6,-34,48.6).curveTo(-34,48.6,-33.9,48.6).lineTo(-33.7,48.7).lineTo(-35,48.7).lineTo(-34.7,48.6).curveTo(-34.7,48.6,-34.6,48.6).curveTo(-34.6,48.6,-34.6,48.6).curveTo(-34.6,48.5,-34.6,48.5).curveTo(-34.6,48.5,-34.6,48.4).lineTo(-34.6,46.8).lineTo(-34.5,46.4).lineTo(-34.3,46.1).lineTo(-33.9,45.8).lineTo(-33.5,45.5).lineTo(-33.9,45.3).lineTo(-34.3,45).lineTo(-34.5,44.7).lineTo(-34.6,44.3).lineTo(-34.6,43.3).curveTo(-34.6,43.3,-34.6,43.3).curveTo(-34.6,43.2,-34.6,43.2).curveTo(-34.6,43.2,-34.6,43.2).curveTo(-34.7,43.1,-34.7,43.1).lineTo(-35,43.1).lineTo(-35,43).lineTo(-32.6,43).lineTo(-32,43.1).lineTo(-31.5,43.4).curveTo(-31.3,43.6,-31.2,43.8).lineTo(-31.2,44.3).lineTo(-31.2,44.8).lineTo(-31.6,45.2).lineTo(-32.1,45.5).lineTo(-32.7,45.6).lineTo(-32.8,45.6).lineTo(-31,48.4).lineTo(-30.8,48.6).lineTo(-30.4,48.7).closePath().moveTo(-34.1,44.1).curveTo(-34.1,44.9,-33.8,45.2).curveTo(-33.6,45.5,-32.9,45.5).lineTo(-32.4,45.5).lineTo(-32,45.2).curveTo(-31.9,45.2,-31.9,45.2).curveTo(-31.9,45.1,-31.8,45.1).curveTo(-31.8,45,-31.8,45).curveTo(-31.7,44.9,-31.7,44.9).lineTo(-31.6,44.3).curveTo(-31.6,43.7,-31.9,43.4).curveTo(-32.1,43.1,-32.8,43.1).lineTo(-34.1,43.1).closePath().moveTo(-57.1,48.7).lineTo(-56.7,48.6).curveTo(-56.7,48.6,-56.7,48.6).curveTo(-56.7,48.6,-56.6,48.6).curveTo(-56.6,48.5,-56.6,48.5).curveTo(-56.6,48.5,-56.6,48.4).lineTo(-56.6,46.8).lineTo(-56.5,46.4).lineTo(-56.4,46.1).lineTo(-56.1,45.8).lineTo(-55.5,45.5).lineTo(-56.1,45.3).lineTo(-56.4,45).lineTo(-56.5,44.7).lineTo(-56.6,44.3).lineTo(-56.6,43.3).curveTo(-56.6,43.3,-56.6,43.3).curveTo(-56.6,43.2,-56.6,43.2).curveTo(-56.7,43.2,-56.7,43.2).curveTo(-56.7,43.1,-56.7,43.1).lineTo(-57.1,43.1).lineTo(-57.1,43).lineTo(-53.7,43).lineTo(-53.6,44).lineTo(-53.7,44).lineTo(-53.8,43.5).lineTo(-53.9,43.3).lineTo(-54.2,43.1).lineTo(-54.5,43.1).lineTo(-56.2,43.1).lineTo(-56.2,44.1).curveTo(-56.2,44.9,-56,45.2).curveTo(-55.6,45.5,-55,45.5).lineTo(-54.8,45.5).lineTo(-54.7,45.4).lineTo(-54.6,45.1).lineTo(-54.6,44.6).lineTo(-54.5,44.6).lineTo(-54.5,47).lineTo(-54.6,47).lineTo(-54.6,46.3).lineTo(-54.7,45.8).lineTo(-54.8,45.6).lineTo(-55,45.6).curveTo(-55.6,45.6,-56,45.9).curveTo(-56.2,46.2,-56.2,47).lineTo(-56.2,48.6).lineTo(-54.8,48.6).lineTo(-54.3,48.6).curveTo(-54.2,48.6,-54.2,48.5).curveTo(-54.1,48.5,-54.1,48.5).curveTo(-54,48.5,-54,48.4).curveTo(-54,48.4,-53.9,48.4).lineTo(-53.7,48).lineTo(-53.6,47.2).lineTo(-53.4,47.2).lineTo(-53.7,48.7).closePath().moveTo(-79.4,48.7).lineTo(-79.1,48.6).curveTo(-79.1,48.6,-79.1,48.6).curveTo(-79,48.6,-79,48.6).curveTo(-79,48.5,-79,48.5).curveTo(-78.9,48.5,-78.9,48.4).lineTo(-78.9,47).lineTo(-78.9,46.7).lineTo(-78.8,46.3).lineTo(-78.4,46).lineTo(-77.9,45.8).lineTo(-78.4,45.6).lineTo(-78.8,45.3).lineTo(-78.9,44.9).lineTo(-78.9,44.6).lineTo(-78.9,43.3).curveTo(-78.9,43.3,-79,43.3).curveTo(-79,43.2,-79,43.2).curveTo(-79,43.2,-79.1,43.2).curveTo(-79.1,43.1,-79.1,43.1).lineTo(-79.5,43.1).lineTo(-79.5,43).lineTo(-77,43).lineTo(-76.3,43.1).lineTo(-75.9,43.4).lineTo(-75.5,43.9).lineTo(-75.4,44.4).curveTo(-75.4,44.8,-75.6,45).curveTo(-75.8,45.3,-76,45.5).lineTo(-76.4,45.7).lineTo(-77.1,45.8).lineTo(-77.1,45.8).curveTo(-77.8,45.8,-78.2,46.2).curveTo(-78.6,46.5,-78.6,47.2).lineTo(-78.6,48.4).curveTo(-78.6,48.5,-78.5,48.5).curveTo(-78.5,48.5,-78.5,48.6).curveTo(-78.5,48.6,-78.5,48.6).curveTo(-78.4,48.6,-78.4,48.6).lineTo(-78.1,48.7).closePath().moveTo(-78.6,44.4).curveTo(-78.6,45.1,-78.3,45.4).curveTo(-78,45.7,-77.3,45.7).lineTo(-77.2,45.7).lineTo(-76.8,45.7).lineTo(-76.3,45.5).lineTo(-76.1,45.1).lineTo(-76,44.4).curveTo(-75.9,43.8,-76.2,43.5).curveTo(-76.4,43.1,-77.1,43.1).lineTo(-78.6,43.1).closePath().moveTo(50.4,23.3).curveTo(49.2,21.6,49.1,19).curveTo(49,16.4,49.8,12.9).curveTo(50.4,9.4,51.7,5.2).curveTo(53,0.9,54.6,-3.7).lineTo(68.8,-48.3).lineTo(72.3,-48.3).lineTo(94.1,20.4).curveTo(94.7,22.6,96.3,23.4).curveTo(97.9,24,100,24).lineTo(100,24.8).lineTo(83.4,24.8).lineTo(83.4,24).curveTo(85.5,24,87.5,23.4).curveTo(89.4,22.8,88.7,20.8).lineTo(80.3,-5.3).curveTo(78.6,-4.6,77.2,-3.1).curveTo(75.9,-1.7,74.8,0.2).curveTo(73.7,2.2,72.7,4.5).lineTo(70.9,9).lineTo(68.2,14.9).curveTo(66.9,17.9,65,20.2).curveTo(63.2,22.5,60.8,23.9).curveTo(58.4,25.2,55.1,25.2).curveTo(51.9,25.2,50.4,23.3).closePath().moveTo(55.6,-2.5).lineTo(53.1,5.7).curveTo(51.8,9.7,51.2,12.9).curveTo(50.4,16.2,50.5,18.7).curveTo(50.5,21.2,51.5,22.5).curveTo(52.7,24,55.1,24).curveTo(57.2,24,58.7,22.7).curveTo(60.1,21.4,61.5,19.1).curveTo(62.7,16.9,63.9,14.1).lineTo(66.3,8.5).curveTo(67.5,5.6,68.8,3.1).curveTo(69.9,0.6,71.6,-1.4).curveTo(73.3,-3.5,75.2,-4.8).curveTo(77.3,-6,80.1,-6).lineTo(68.4,-42.9).closePath().moveTo(-31.9,22.6).curveTo(-37.8,19.9,-42.1,15).curveTo(-46.4,10.1,-48.9,3.4).curveTo(-51.3,-3.4,-51.3,-11.7).curveTo(-51.3,-20,-48.9,-26.8).curveTo(-46.4,-33.7,-42.1,-38.6).curveTo(-37.8,-43.5,-31.9,-46.1).curveTo(-26,-48.8,-18.9,-48.8).curveTo(-11.9,-48.8,-6,-46.1).curveTo(-0.1,-43.5,4.1,-38.6).curveTo(8.5,-33.7,11,-26.8).curveTo(13.4,-20,13.3,-11.7).curveTo(13.4,-3.4,11,3.4).curveTo(8.5,10.1,4.1,15).curveTo(-0.1,19.9,-6,22.6).curveTo(-11.9,25.2,-18.9,25.2).curveTo(-26,25.2,-31.9,22.6).closePath().moveTo(-30.1,-44.7).curveTo(-35,-42,-38.4,-37.2).curveTo(-42,-32.4,-43.7,-25.9).curveTo(-45.6,-19.3,-45.5,-11.7).curveTo(-45.6,-4.1,-43.7,2.5).curveTo(-42,9,-38.4,13.8).curveTo(-35,18.6,-30.1,21.3).curveTo(-25.1,24,-18.9,24).curveTo(-12.8,24,-7.8,21.3).curveTo(-2.8,18.6,0.5,13.8).curveTo(4,9,5.8,2.5).curveTo(7.6,-4.1,7.6,-11.7).curveTo(7.6,-19.3,5.8,-25.9).curveTo(4,-32.4,0.5,-37.2).curveTo(-2.8,-42,-7.8,-44.7).curveTo(-12.8,-47.4,-18.9,-47.4).curveTo(-25.1,-47.4,-30.1,-44.7).closePath().moveTo(22.9,24.8).lineTo(22.9,24).curveTo(25.2,24,27,23.5).curveTo(28.8,22.9,28.9,20.9).lineTo(28.9,-13.9).lineTo(10.3,-43.8).curveTo(9,-45.9,7.5,-46.7).curveTo(6.1,-47.6,3.9,-47.6).lineTo(3.9,-48.3).lineTo(21.4,-48.3).lineTo(21.4,-47.6).curveTo(18.1,-47.6,16.6,-46.8).curveTo(15.1,-46,16.2,-44.2).lineTo(33.7,-15.9).lineTo(50.2,-43.5).curveTo(51.4,-45.3,50,-46.5).curveTo(48.7,-47.6,45.5,-47.6).lineTo(45.5,-48.3).lineTo(58.6,-48.3).lineTo(58.6,-47.6).curveTo(56.5,-47.6,54.6,-46.3).curveTo(52.7,-45.1,51.5,-43).lineTo(34,-14).lineTo(34,20.9).curveTo(34,22.9,36,23.5).curveTo(37.8,24,39.9,24).lineTo(39.9,24.8).closePath().moveTo(-59.7,24.8).lineTo(-59.7,24).curveTo(-56.6,24,-55.1,23.4).curveTo(-53.4,22.7,-54.7,20.6).lineTo(-77.6,-14.5).curveTo(-82.8,-13.2,-85.9,-9.2).curveTo(-88.9,-5.1,-88.9,2.2).lineTo(-88.9,20.9).curveTo(-88.9,22.9,-86.9,23.5).curveTo(-85,24,-82.8,24).lineTo(-82.8,24.8).lineTo(-100,24.8).lineTo(-100,24).curveTo(-97.8,24,-96,23.5).curveTo(-94.1,22.9,-94.1,20.9).lineTo(-94.1,-0.1).curveTo(-94.1,-2.3,-93.3,-4.7).curveTo(-92.6,-7.1,-91.1,-9.3).curveTo(-89.4,-11.5,-86.9,-13.3).curveTo(-84.4,-15.1,-80.6,-15.9).curveTo(-84.4,-16.8,-86.9,-18.6).curveTo(-89.4,-20.4,-91.1,-22.6).curveTo(-92.6,-24.7,-93.3,-27.1).curveTo(-94.1,-29.5,-94.1,-31.7).lineTo(-94.1,-44.4).curveTo(-94.1,-46.5,-96,-47).curveTo(-97.8,-47.5,-100,-47.5).lineTo(-100,-48.3).lineTo(-69.5,-48.3).curveTo(-64.9,-48.3,-61.4,-47).curveTo(-58,-45.8,-55.6,-43.5).curveTo(-53.2,-41.2,-52,-38.2).curveTo(-50.8,-35.3,-50.9,-31.7).curveTo(-50.9,-28,-52.5,-25).curveTo(-54.1,-22,-56.8,-19.8).curveTo(-59.5,-17.6,-63.2,-16.5).curveTo(-66.6,-15.3,-70.6,-15.3).lineTo(-70.8,-15.3).lineTo(-71.4,-15.3).lineTo(-71.8,-15.2).lineTo(-48.4,20.6).curveTo(-47.1,22.6,-45.6,23.3).curveTo(-44.1,24,-41.9,24).lineTo(-41.9,24.8).closePath().moveTo(-88.9,-34).curveTo(-88.9,-24.6,-85.3,-20.6).curveTo(-81.8,-16.5,-73.5,-16.5).lineTo(-73.4,-16.5).curveTo(-70.2,-16.5,-67.2,-17.3).curveTo(-64.2,-18.1,-61.8,-19.8).curveTo(-59.6,-21.6,-58.1,-24.5).curveTo(-56.6,-27.4,-56.6,-31.7).curveTo(-56.6,-39.2,-60.2,-43.1).curveTo(-63.7,-46.9,-71.3,-46.9).lineTo(-88.9,-46.9).closePath();
	this.shape.setTransform(100,48.775);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_small, new cjs.Rectangle(0,0,200,97.6), null);


(lib.logo_large = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.Bitmap1();
	this.instance.setTransform(62.6,75.75,0.154,0.154);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_large, new cjs.Rectangle(62.6,75.8,140.8,67.89999999999999), null);


(lib.botoes = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-236.1,78).lineTo(-236.1,-78).lineTo(236.1,-78).lineTo(236.1,78).closePath();
	this.shape.setTransform(236.05,78.025);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,472.1,156.1);


(lib.background_effect = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_40 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(40).call(this.frame_40).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {capa:0,localizacao:1,ficha:2,projetistas:3,implantacoes:4,plantas:5,imagens:6,vistas:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(8));

	// blur
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(0,0,0,0.247)").beginStroke().moveTo(-959.7,540).lineTo(-959.7,-540).lineTo(959.7,-540).lineTo(959.7,540).closePath();
	this.shape.setTransform(959.725,540);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},1).wait(7));

	// background
	this.instance = new lib.Bitmap2();
	this.instance.setTransform(1.25,0.15);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(7));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1921.3,1080.2);


(lib.arrow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#E8DDD5").beginStroke().moveTo(-24,12).lineTo(0,-12).lineTo(24,12).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24,-12,48,24);


(lib.stripe_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"in":0,out:10};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTapParent = window.parent.AllTap;
		
		
		AllTapParent.emit('animateend', {in: true});
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTapParent = window.parent.AllTap;
		
		
		AllTapParent.emit('animateend', {out: true});
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// stripe
	this.instance = new lib.stripe("synched",0);
	this.instance.setTransform(0,45);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:-40},5).to({y:-35},2).to({y:-45},2).to({startPosition:0},1).to({y:-35},2).to({y:-40},2).to({y:45},5).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-41,-90,82.1,180);


(lib.menu_background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// menu_line_solid
	this.instance = new lib.menu_line_solid();
	this.instance.setTransform(960,-80,1,1,0,0,0,960,0);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// menu_line_gradient
	this.instance_1 = new lib.menu_line_gradient();
	this.instance_1.setTransform(1240,-79,1,1,0,0,0,680,1);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#644532","#000000"],[0,1],-6.7,-52.1,-6.7,132.9).beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,-40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_background, new cjs.Rectangle(-1,-81,1922,81), null);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// blur
	this.occ_background_dynamic = new lib.background_dynamic();
	this.occ_background_dynamic.name = "occ_background_dynamic";

	this.timeline.addTween(cjs.Tween.get(this.occ_background_dynamic).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(0,0,1921.3,1080.2), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(9).call(this.frame_9).wait(1));

	// arrow
	this.instance = new lib.arrow("synched",0);
	this.instance.setTransform(0,12);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:-26},5).to({y:-12},2).to({x:0.3,y:-18.4},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24,-38,48.3,62);


(lib.menu_marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"capa":0,"localizacao":1,"projetistas":2,"plantas":3,"imagens":4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// arrow_up
	this.occ_animate = new lib.arrow_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(44.45,0);

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(1).to({x:257.85},0).wait(1).to({x:498.3},0).wait(1).to({x:714.2},0).wait(1).to({x:914.15},0).wait(1));

	// stripe_up
	this.occ_animate_1 = new lib.stripe_up();
	this.occ_animate_1.name = "occ_animate_1";
	this.occ_animate_1.setTransform(36.05,0,0.8782,1);
	this.occ_animate_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate_1).to({_off:true},1).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,938.2,90);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0];
	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const 
			AllTap = window.AllTap,
			name_current = 'index';
		
		/**
		 *
		 *  @param object
		 *  Set "this", object of canvas CreateJs.
		 */
		AllTap.setState({...AllTap.state, [`_this_${name_current}`]: this});
		
		/**
		 *
		 * @param array
		 *  [{
		 *      name: {string} = Name of occurrence not prefixed here "btn_".
		 *      occ_logo_large: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_logo_medium: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_logo_small: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_background: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_background_dynamic: {boolean} = Is visible (optional), go to label current !this is hide by default.
		 *      occ_background_effect: {boolean} = Is visible (optional), auto executable movie clip in frame 0 !this is hide by default.
		 *      occ_external: {boolean} = Is visible (optional), open in new page target="_blank".
		 *      occ_video: {boolean} = Is button video, run outside the iFrame (optional).
		 *      occ_tour: {boolean} = Is button tour, run outside the iFrame (optional).
		 *            src: URL of external and video or tour.
		 *      page_default: {boolean} = Define function $page_default() "root", finish of video (optional).
		 *  }]
		 */
		AllTap.createMenu([
		    {
		        name: 'capa',
				occ_background: false,
				occ_background_dynamic: true,
		        page_default: true
		    },
		    {
		        name: 'localizacao',
				occ_background: true,
				occ_logo_large: true
		    },
		    {
		        name: 'projetistas',
				occ_background: true,
				occ_logo_large: true
		    },
		    {
		        name: 'plantas',
				occ_background: true,
				occ_logo_large: true
		    },
		    {
		        name: 'imagens',
				occ_background: true,
				occ_logo_large: true
		    }
		]);
		
		
		function prevMain() {
			window.open('http://portal-roya-web.local', "_self");
		}
		
		this.btn_sign_out.addEventListener("click", prevMain);
		/*this.btSair.addEventListener("click", fl_sair);
		
		function fl_sair() {
			window.open("./../../index.html", "_self");
		}*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// BackgroundEffect
	this.occ_background_effect = new lib.background_effect();
	this.occ_background_effect.name = "occ_background_effect";

	this.timeline.addTween(cjs.Tween.get(this.occ_background_effect).wait(1));

	// LogoLarge
	this.occ_logo_large = new lib.logo_large();
	this.occ_logo_large.name = "occ_logo_large";
	this.occ_logo_large.setTransform(105.35,930.5,1,1.0001,0,0,0,0,0.2);
	this.occ_logo_large.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo_large).wait(1));

	// LogoSmall
	this.occ_logo_small = new lib.logo_small();
	this.occ_logo_small.name = "occ_logo_small";
	this.occ_logo_small.setTransform(140.15,972.55,0.9998,0.9998,0,0,0,0.1,0.1);
	this.occ_logo_small.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo_small).wait(1));

	// SignOutButton
	this.btn_sign_out = new lib.botoes();
	this.btn_sign_out.name = "btn_sign_out";
	this.btn_sign_out.setTransform(1871.25,1000.15,0.1059,0.5127);
	new cjs.ButtonHelper(this.btn_sign_out, 0, 1, 2, false, new lib.botoes(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_sign_out).wait(1));

	// sign_out_text
	this.instance = new lib.sign_out_text();
	this.instance.setTransform(1900,1040,1,1,0,0,0,13.2,18.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// sign_out_background
	this.instance_1 = new lib.sign_out_background();
	this.instance_1.setTransform(1900,1040,1,1,0,0,0,20,30);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// MenuButton
	this.btn_capa = new lib.botoes();
	this.btn_capa.name = "btn_capa";
	this.btn_capa.setTransform(475.8,1010.85,0.1883,0.3843,0,0,0,0.6,0);
	new cjs.ButtonHelper(this.btn_capa, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_localizacao = new lib.botoes();
	this.btn_localizacao.name = "btn_localizacao";
	this.btn_localizacao.setTransform(651.85,1010.85,0.3469,0.3846,0,0,0,0.5,0);
	new cjs.ButtonHelper(this.btn_localizacao, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_plantas = new lib.botoes();
	this.btn_plantas.name = "btn_plantas";
	this.btn_plantas.setTransform(1133.05,1010.85,0.2367,0.3846,0,0,0,0.7,0);
	new cjs.ButtonHelper(this.btn_plantas, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_imagens = new lib.botoes();
	this.btn_imagens.name = "btn_imagens";
	this.btn_imagens.setTransform(1329.55,1010.85,0.2413,0.3843,0,0,0,0.4,0);
	new cjs.ButtonHelper(this.btn_imagens, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_projetistas = new lib.botoes();
	this.btn_projetistas.name = "btn_projetistas";
	this.btn_projetistas.setTransform(900.95,1010.85,0.3099,0.3843,0,0,0,0.3,0);
	new cjs.ButtonHelper(this.btn_projetistas, 0, 1, 2, false, new lib.botoes(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_projetistas},{t:this.btn_imagens},{t:this.btn_plantas},{t:this.btn_localizacao},{t:this.btn_capa}]}).wait(1));

	// MenuText
	this.instance_2 = new lib.CachedBmp_41();
	this.instance_2.setTransform(606.15,1032.2,0.5,0.5);

	this.instance_3 = new lib.CachedBmp_40();
	this.instance_3.setTransform(1341,1025.75,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_39();
	this.instance_4.setTransform(660.25,1025.75,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_38();
	this.instance_5.setTransform(1143.95,1025.75,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_37();
	this.instance_6.setTransform(910.35,1025.75,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_36();
	this.instance_7.setTransform(485.05,1025.75,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(1));

	// MenuMarker
	this.occ_menu_marker = new lib.menu_marker();
	this.occ_menu_marker.name = "occ_menu_marker";
	this.occ_menu_marker.setTransform(472.25,1080);
	this.occ_menu_marker.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,-1,3);

	this.timeline.addTween(cjs.Tween.get(this.occ_menu_marker).wait(1));

	// MenuBackground
	this.occ_menu_background = new lib.menu_background();
	this.occ_menu_background.name = "occ_menu_background";
	this.occ_menu_background.setTransform(0,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_menu_background).wait(1));

	// background
	this.occ_background = new lib.background();
	this.occ_background.name = "occ_background";
	this.occ_background.setTransform(960,500,1,1,0,0,0,960,500);
	this.occ_background.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_background).wait(1));

	// BackgroundDynamic
	this.occ_background_dynamic = new lib.background_dynamic();
	this.occ_background_dynamic.name = "occ_background_dynamic";

	this.timeline.addTween(cjs.Tween.get(this.occ_background_dynamic).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(959,540,962.3,637);
// library properties:
lib.properties = {
	id: '7C9EF5D5AF5D5F46AFF0D236F6A9A88F',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#6E3913",
	opacity: 0.00,
	manifest: [
		{src:"./images/index_atlas_1.png", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['7C9EF5D5AF5D5F46AFF0D236F6A9A88F'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
